if(!customElements.get('faq-links')) {
  class ComponentFaqLinks extends HTMLElement {
    constructor() {
      super();
      var parser = new DOMParser();
      var articles = [];
      var leftParent = this.querySelector('.left-links');
      var rightParent = this.querySelector('.right-links');
      var self = this;
      
      $s.get({
        url: this.dataset.blogUrl + '/tagged/'+ this.dataset.articleTag + '?view=link_articles',
        cache: false,
        success: function(data){        
          var doc = parser.parseFromString(data, 'text/html');
          var elements = doc.querySelectorAll('a.article-link');
          elements.forEach(element=>{
            if(element.dataset.articleId != self.dataset.articleId){
              articles.push(element);
            }
          })
          const halfPoint = Math.ceil(articles.length/2);
          const firstPart = articles.slice(0, halfPoint);
          const secondPart = articles.slice(halfPoint);

          firstPart.forEach(articleHtml => {
            leftParent.insertAdjacentHTML('beforeend', articleHtml.outerHTML); // Appends at the end
          });
          secondPart.forEach(articleHtml => {
            rightParent.insertAdjacentHTML('beforeend', articleHtml.outerHTML); // Appends at the end
          });
        },
        error: (e)=>{
          console.log("Error fetching articles", e);
          self.closest('.faq-links-container').classList.add('hide');
        }
      })
    }



  }
  customElements.define('faq-links', ComponentFaqLinks);
}